<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Reports" title="Products Report" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
				<div class="card">
					<div class="card-body">
	
						<div class="col-md-12 project-list page-subtitle">
							<div class="row">
								<div class="col-md-10 d-flex">
									<span style="font-size: 20px; font-weight: bolder;">Products Report</span>
								</div>
							</div>
						</div>
	
						<div class="col-md-12 project-list filter-sort">
							<div class="row">
								<div class="col-md-4" style="margin-top: 27px;">
									<label class="d-flex listing-length"><span>Show</span>
										<select class="form-select" v-model="listing_length" @change="fetchReport()">
											<option value="5">5</option>
											<option value="10">10</option>
											<option value="20">20</option>
										</select>
										<span>entries</span>
									</label>
								</div>
										
								<div class="col-md-3">
									<label class="control-label">Start Date:<span class="text-danger">*</span></label>
									<input class="form-control" type="date" v-model="start_date" :min="min" :max="max" value-as-string @input="fetchReport()">
								</div>
								<div class="col-md-3">
									<label class="control-label">End Date:<span class="text-danger">*</span></label>
									<input class="form-control" type="date" v-model="end_date" :min="min" :max="max" value-as-string  @input="fetchReport()">
								</div>
								<div class="col-md-2" style="margin-top: 27px;">
									<div class="btn btn-info" v-if="Boolean(products.length)" @click="generatePDF()">Pdf</div>
								</div>
										
							</div>
						</div>
	
						<div class="table-responsive product-table">
							<table class="display" id="basic-1">
								<thead>
								<tr>
										<th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
											aria-sort="ascending" aria-label="Image: activate to sort column descending"
											style="width: 215.266px;">Image</th>
										<th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
											aria-sort="ascending" aria-label="Ad.Id: activate to sort column descending"
											style="width: 215.266px;">Ad.Id</th>
										<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
											aria-label="Title: activate to sort column ascending"
											style="width: 275.797px;">Title</th>
										<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
											aria-label="Price: activate to sort column ascending"
											style="width: 245.797px;">Price</th>
										<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
											aria-label="Location: activate to sort column ascending"
											style="width: 415.797px;">Location</th>
										<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
											aria-label="Posted by: activate to sort column ascending"
											style="width: 215.266px;">Posted by</th>	
										<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
											aria-label="Posted on: activate to sort column ascending"
											style="width: 215.797px;">Posted on</th>
										<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
											aria-label="Options: activate to sort column ascending"
											style="width: 215.266px;">Options</th>	
								</tr>
								</thead>
								<tbody v-if="Boolean(products.length)">
									<tr v-for="product in products" :key="product.id">
										<td><img v-if="product.image" :src="$image_url + product.image" alt="Image not found" class="avatar-60" /></td>
										<td>{{ product.ad_id }}</td>
										<td>{{ product.title }}</td>
										<td><p style="width: 120px;">Rs. {{ product.price }}</p></td>
										<td>{{product.location}}</td>
										<td>
											{{ product.user_email }}<br />
											{{ product.user_phone }}
										</td>
										<td><p style="width: 100px;">{{$filters.formatDateTime(product.created_at)}}</p></td>
										<td><router-link :to="{name: 'product.show', params: { id: product.id }}" class="btn btn-sm btn-primary mt-2 mr-1" >View</router-link></td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr>
										<td colspan="8" class="text-center">No data</td>
									</tr>
								</tbody>
							</table>
						</div>

						<!----pagination starts --->
						<nav aria-label="Page navigation" class="mt-2">
							<ul class="pagination">
								<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
									<a class="page-link" href="#" @click.prevent="fetchReport(page.url + '&start_date=' + start_date + '&end_date=' + end_date +  '&limit=' + listing_length)" tabindex="-1">
										<span v-if="index == 0">Prev</span>
										<span v-else-if="index == pagination.length - 1">Next</span>
										<span v-else>{{ page.label }}</span>
									</a>
								</li>
							</ul>
						</nav>
						<!----pagination ends --->
	
					</div>
				</div>
				</div>
			</div>
		</div>
 
 
	  
   </div>
</template>


<script>
	export default {
	
		data() {

			const now = new Date()
	      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
	      const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
	      const minDate = new Date('2021-01-01') 
	      
			return {
				products: [],
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",				
			};
		},
		mounted() {},

		created() {
			this.fetchReport();			
		},

		methods: {

			
			fetchReport(page_url = null) {
				let url = "/api/admin/reports/products?start_date=" + this.start_date + "&end_date=" + this.end_date + "&limit=" + this.listing_length;
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.products = responseData.data;
						this.pagination = responseData.links;
					})
					.catch((err) => console.log(err));
			},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			generatePDF() {
				this.getToken();
				let page_url = "/api/admin/reports/products_pdf?start_date=" + this.start_date + "&end_date=" + this.end_date;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
					.then((response) => {

						let blob = new Blob([response.data], { type: "application/pdf" });
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "productsReport" + this.start_date + "_" + this.end_date + ".pdf";
						link.click();
						
					})
					.catch((err) => console.log(err));
			},
		},
	};
</script>
